import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Body from './Components/BodyComp/body';
import Footer from './Components/MainComp/footer';
import { NavComp } from './Components/MainComp/nav';
import ContactUs from './Components/ContactComp/contactus';
import AboutUs from './Components/AboutComp/aboutus';
// import FindYourOptometrist from './Components/FindOptometrist/findyouroptometrist';
import EventAndNews from './Components/EventNewsComp/eventandnews';
import Leadership from './Components/AboutComp/leadership';
import Advocacy from './Components/AdvocacyComp/advocacy';
import JoinUsForm from './Components/BodyComp/joinusform';
import ChatBot from './Components/BotComp/charbot';
import SchoolEyeCare from './Components/AdvocacyComp/schooleyecare';
// import PolicyAlert from './Components/AdvocacyComp/policyalert';
import AdvocacyVolunteer from './Components/AdvocacyComp/advocacyvolunteer';
import FAQ from './Components/InfomationComp/faq';
import PrivacyPolicy from './Components/InfomationComp/privacypolicy';
import TermsAndConditions from './Components/InfomationComp/termsandconditions';

import JoinToEffect from './Components/AdvocacyComp/jointoeffort';
import Payment from './Components/DownloadComp/payment-portal';
import AdminPanel from './Components/AdminComp/adminpanel';
import PrivateRoute from './Utils/PrivateRoute';
import SignIn from './Components/LoginComp/signin';
import SignUp from './Components/LoginComp/signup';
import ForgotPassword from "./Components/LoginComp/ForgotPassword";
import UserProfile from './Components/UserComp/userprofile';
import ViewApplication   from './Components/UserComp/viewapplication';
import ViewPayment from './Components/UserComp/viewpayment';
import FollowupResources from './Components/UserComp/followup-resources'; 
import KnowledgeQuest from './Components/UserComp/knowledge -quest';




function App() {

  return (
    <Router>
      <NavComp />
      <Routes>
        <Route path="/" element={<Body />} />

        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/leadership" element={<Leadership />} />
        <Route path="/eventandnews" element={<EventAndNews />} />
        {/* <Route path="/findyouroptometrist" element={<FindYourOptometrist />} /> */}
        <Route path="/advocacy" element={<Advocacy />} />
        <Route path="/joinusform" element={<JoinUsForm />} />
        <Route path="/schooleyecare" element={<SchoolEyeCare />} />
        {/* <Route path="/policyalert" element={<PolicyAlert />} /> */}
        <Route path="/advocacyvolunteer" element={<AdvocacyVolunteer />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/termsandconditions" element={<TermsAndConditions />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/jointoeffort" element={<JoinToEffect />} />
        <Route path="/payment-portal" element={<Payment />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />
        <Route path='/viewapplication' element={<ViewApplication />} />
        <Route path='/viewpayment' element={<ViewPayment />} />
        <Route path='/followup-resources' element={<FollowupResources />} />
        <Route path='/knowledge-quest' element={<KnowledgeQuest />} />
        
    





        <Route
          path="/userprofile"
          element={
            <PrivateRoute>
                <UserProfile />
            </PrivateRoute>
          }
        />

                    
                     
        
                <Route
          path="/adminpanel"
          element={
            <PrivateRoute>
              <AdminPanel />
            </PrivateRoute>
          }
        />




        </Routes>
        <ChatBot />
      <Footer />
    </Router>
  );
}

export default App;



